import { Fragment, useState, useContext } from 'react'
import { Visible } from '@leroy-merlin-br/backyard-react-ui'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import LoggedInBox from './components/LoggedInBox'
import LoggedOutBox from './components/LoggedOutBox'

const MyAccount = () => {
  const context = useContext(HeaderContext)
  const {
    isLogged,
    userResources
  } = context

  const [isEnabled, setIsEnabled] = useState(false)

  const toggleDropdownUser = () => {
    setIsEnabled(!isEnabled)
  }

  const showUserName = () => (
    isLogged
      ? (
        <Fragment>
          <span>Olá,</span>
          <strong
            className="my-account-name-limit"
            title={ userResources.name }
          >
          { userResources.name }
          </strong>
        </Fragment>
        )
      : (
        <Fragment>
          <span>Entrar</span>
          <strong>Minha conta</strong>
        </Fragment>
        )
  )

  return (
    <section className="my-account">
      <div className="my-account-group" onClick={ toggleDropdownUser }>
        <i className="glyph glyph-silhouette"></i>
        <Visible giga tera>
          <div className="content">
            { showUserName() }
          </div>
        </Visible>
      </div>
      {
        isEnabled &&
          <Fragment>
            <span className="my-account-overlay" onClick={ toggleDropdownUser }></span>
            <div className="my-account-box">
              {
                isLogged
                  ? <LoggedInBox />
                  : <LoggedOutBox />
              }
            </div>
          </Fragment>
      }
    </section>
  )
}

export default MyAccount
